<template>
  <div class="btn-group"><button type="button" class="btn btn-success">Action</button>
    <button type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown">
      <span class="caret"></span>
      <span class="sr-only">Toggle Dropdown</span>
    </button>
    <ul class="dropdown-menu" role="menu">
      <li><a href="#">Action</a></li>
      <li><a href="#">Another action</a></li>
      <li><a href="#">Something else here</a></li>
      <li class="divider"></li>
      <li><a href="#">Separated link</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BtnGroupWrapper'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/BtnGroupWrapper.vue